// services/hospitals.ts
import { AuthFetch } from "../hooks/useApi";
import {
  Hospital,
  HospitalCreatePayload,
  HospitalUpdatePayload,
  DoctorHospitalsResponse,
  DoctorHospitalLinkPayload,
} from "../types/hospital.types";

export const hospitalService = {

  create: (
    apiFetch: AuthFetch,
    payload: HospitalCreatePayload,
  ): Promise<Hospital> =>
    apiFetch<Hospital>(`/hospitals/`, {
      method: "POST",
      body:   JSON.stringify(payload),
    }),

  search: (
    apiFetch: AuthFetch,
    query: string,
  ): Promise<Hospital[]> =>
    apiFetch<Hospital[]>(`/hospitals/search?q=${encodeURIComponent(query)}`, {
      method: "GET",
    }),

  get: (
    apiFetch: AuthFetch,
    id: number,
  ): Promise<Hospital> =>
    apiFetch<Hospital>(`/hospitals/${id}`, {
      method: "GET",
    }),

  update: (
    apiFetch: AuthFetch,
    id: number,
    payload: HospitalUpdatePayload,
  ): Promise<Hospital> =>
    apiFetch<Hospital>(`/hospitals/${id}`, {
      method: "PUT",
      body:   JSON.stringify(payload),
    }),

  listForDoctor: (
    apiFetch: AuthFetch,
    doctorEmail: string,
  ): Promise<DoctorHospitalsResponse> =>
    apiFetch<DoctorHospitalsResponse>(`/doctors/${doctorEmail}/hospitals`, {
      method: "GET",
    }),

  linkToDoctor: (
    apiFetch: AuthFetch,
    doctorEmail: string,
    payload: DoctorHospitalLinkPayload,
  ): Promise<void> =>
    apiFetch<void>(`/doctors/${doctorEmail}/hospitals`, {
      method: "POST",
      body:   JSON.stringify(payload),
    }),

  unlinkFromDoctor: (
    apiFetch: AuthFetch,
    doctorEmail: string,
    hospitalId: number,
  ): Promise<void> =>
    apiFetch<void>(`/doctors/${doctorEmail}/hospitals/${hospitalId}`, {
      method: "DELETE",
    }),
};
